<template>
  <v-layout justify-center>
    <!-- When there is rounds -->
    <v-flex xs12 v-if="rounds && rounds.length>0">
      <!-- TIRAR ESSE IF DAKI -->
      <v-toolbar
        color="black"
        dark
        tabs
        v-model="toolbarID"
        style="border-top-left-radius: 10px; border-top-right-radius: 10px"
      >
        <!-- Toolbar increments until the number_rounds creatred and decreases until firts round -->
        <v-btn icon flat :disabled="toolbarID<1" @click="toolbarID=toolbarID-1">
          <v-icon dark>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title class="ml-0">{{rounds[toolbarID].name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          flat
          :disabled="toolbarID+1>rounds.length"
          @click="passRound(), checkCreateRound()"
        >
          <v-icon dark>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px">
        <router-view></router-view>

        <v-card-actions class="justify-center" v-if="is_owner && !hasWinners">
          <v-btn large round color="primary" @click="createGame=true">
            <v-icon left>fa-plus</v-icon>Novo Jogo
            <v-icon right>far fa-futbol</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex xs12 v-if="rounds && rounds.length==0">
      <div justify-space-around class="text-xs-center mt-3">
        <v-card>
          <h3>Nenhuma rodada criada.</h3>
          <v-btn v-if="is_owner" round dark large color="primary" @click="dialogCreateRound=true">
            <v-icon>add</v-icon>Criar Rodadas
          </v-btn>
        </v-card>
      </div>
    </v-flex>

    <v-dialog v-model="createGame" width="500" persistent scrollable v-if="createGame">
      <v-card style="border-radius:9px">
        <v-card-title class="pa-0">
          <v-toolbar
            color="primary"
            dark
            style="border-top-right-radius: 8px; border-top-left-radius: 8px;"
          >
            <v-toolbar-title class="white--text">Novo Jogo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="createGame=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="newMatch.place" color="primary" box label="Local da Partida"></v-text-field>
          <v-layout row wrap justify-space-around>
            <v-flex xs11 sm5>
              <v-dialog
                ref="dialogTime"
                v-model="modalTime"
                :return-value.sync="newMatch.match_time"
                lazy
                transition="scale-transition"
                width="290px"
              >
                <template>
                  <v-text-field
                    slot="activator"
                    v-model="newMatch.match_time"
                    label="Horário da Partida"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="modalTime"
                  v-model="newMatch.match_time"
                  full-width
                  format="24hr"
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modalTime=false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialogTime.save(newMatch.match_time)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>

            <v-flex xs11 sm5>
              <v-dialog
                ref="dialogDate"
                v-model="modalDate"
                :return-value.sync="date2format"
                persistent
                lazy
                width="290px"
              >
                <template>
                  <v-text-field
                    slot="activator"
                    v-model="newMatch.match_date"
                    label="Dia"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2format" scrollable locale="pt-br">
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialogDate.save(date2format)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-space-around>
            <v-flex xs11 sm5>
              <v-select
                :items="allChampTeams"
                item-value="id"
                item-text="team_name"
                v-model="newMatch.team_A_id"
                label="Time da Casa"
              ></v-select>
            </v-flex>
            <v-flex xs11 sm5>
              <v-select
                :items="allChampTeams"
                item-value="id"
                item-text="team_name"
                v-model="newMatch.team_B_id"
                label="Time Visitante"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            flat
            :disabled="!newMatch.team_A_id && !newMatch.team_B_id"
            @click="addGame()"
          >Adicionar jogo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCreateRound" width="500" persistent v-if="dialogCreateRound">
      <v-card style="border-radius: 9px;">
        <v-toolbar
          color="primary"
          dark
          style="border-top-right-radius: 8px; border-top-left-radius: 8px;"
        >
          <v-toolbar-title class="white--text">Criar Rodada</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" flat icon @click="dialogCreateRound=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- escolher se é grupo ou matamata/finais -->

          <!-- se for grupo: RODADA {{number}} -->
          <!-- se for matamata: options (8,4,semi,final) -->
          <v-radio-group v-model="newRound.kind" row>
            <v-radio label="Fase de grupos" color="primary" value="group_stage" class="my-1"></v-radio>
            <v-radio label="Finais / mata-mata" color="primary" value="finals" class="my-1"></v-radio>
          </v-radio-group>
          <template v-if="newRound.kind == 'group_stage'">
            <v-layout row wrap justify-center>
              <v-flex xs4 md3 lg3>
                <v-text-field
                  v-model="newRound.round_name"
                  color="primary"
                  type="tel"
                  mask="##"
                  suffix="ª Rodada"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </template>
          <template v-if="newRound.kind == 'finals'">
            <v-radio-group v-model="newRound.round_name" column hide-details>
              <v-radio
                label="Oitavas de final"
                color="light-green accent-3"
                value="Oitavas de final"
              ></v-radio>
              <v-radio
                label="Quartas de final"
                color="light-green accent-3"
                value="Quartas de final"
              ></v-radio>
              <v-radio label="Semifinal" color="light-green accent-3" value="Semifinal"></v-radio>
              <v-radio label="Final" color="light-green accent-3" value="Final"></v-radio>
            </v-radio-group>
          </template>
          <!-- <v-text-field v-model="newRound.name" color="primary" box label="Nome da Rodada" ></v-text-field> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat :disabled="!newRound.round_name" @click="addRound()">Criar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <card-loading v-if="loading" :loadText="loadTxt"></card-loading>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapState } from "vuex";

import Api from "../../../api/index";

export default {
  props: {
    champ_teams: {
      type: Array
    },
    rounds_prop: {
      type: Array
    },
    edition_modality_id: {
      type: Number
    }
  },
  data() {
    return {
      rounds: null,
      matches: null,

      avatarSize: 80,
      fab: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      loading: false,

      loadTxt: null,

      toolbarID: 0,
      dialogCreateRound: false, //dialog
      createGame: false, //dialog
      editGame: false, //dialog
      form: false,

      newMatch: {
        round_id: null,
        match_time: null,
        match_date: null,
        team_A_id: null, // home
        team_B_id: null, // away
        place: "Arena Society"
      },

      newRound: {
        name: null,
        kind: "group_stage",
        level_configuration_id: null,
        edition_modality_id: null,
        status_id: null,
        round_name: null
      },
      modalTime: false,
      modal2: false,
      date2format: null,
      date2edit: null,
      modalDate: null,
      date: new Date().toISOString().substr(0, 10)
    };
  },
  methods: {
    getRounds(id) {
      return Api.Championship.indexRounds(id)
        .then(r => r.data)
        .then(data => {
          // console.log({ data });
          this.rounds = data;
        });
    },

    goToMatch(id) {
      this.$router.push({ path: `/sumula/${id}` });
    },
    find_logo(name) {
      return this.team_logos.find(obj => obj.team_name == name)
        ? this.team_logos.find(obj => obj.team_name == name).logo
        : "";
    },
    see_match(match) {
      if (match.ended) this.$router.push(`/sumula/${match.id}`);
    },
    team_inicials(team) {
      let first_letter = team.charAt(0).toUpperCase();
      let last_letter;
      let team_array = team.split(" ");
      if (team_array && team_array.length > 1) {
        last_letter = team_array[team_array.length - 1].charAt(0).toUpperCase();
      } else {
        last_letter = team.charAt(team.length - 1).toUpperCase();
      }
      return first_letter + last_letter;
    },
    formatDate(d) {
      if (!d) return null;
      const [year, month, day] = d.split("-");

      return `${day}/${month}/${year}`;
    },
    checkCreateRound() {
      //esta seria uma função que verificaria se estorou o limite de rounds ou não
      if (this.is_owner) {
        if (
          this.rounds &&
          this.rounds.length > 0 &&
          this.toolbarID + 1 > this.rounds.length
        ) {
          this.dialogCreateRound = true;
        }
      }
    },
    passRound() {
      if (
        this.rounds &&
        this.rounds.length > 0 &&
        this.toolbarID + 1 < this.rounds.length
      ) {
        this.toolbarID = this.toolbarID + 1;
      } else {
        if (this.is_owner) this.dialogCreateRound = true;
      }
    },
    addRound() {
      this.loadTxt = "Salvando";
      this.loading = true;

      this.newRound.edition_modality_id = this.$route.params.id;
      this.newRound.name = this.newRound.round_name;
      if (this.newRound.kind == "group_stage") {
        this.newRound.name += "ª Rodada";
      }
      this.createRound({ newRound: this.newRound }).then(() => {
        this.getRounds(this.$route.params.id).then(() => {
          this.$router.push(
            `/campeonatos/${this.$route.params.id}/jogos/${
              this.rounds[this.rounds.length].id
            }`
          );
        });
      });
    },
    addGame() {
      this.loadTxt = "Salvando";
      this.loading = true;

      this.newMatch.round_id = this.rounds[this.toolbarID].id;
      this.createMatch({ newMatch: this.newMatch });
    },
    // submitEditGame() {
    //   this.loadTxt = "Salvando";
    //   this.loading = true;
    //   this.editGame = false;
    //   this.oneMatch.attributes.match_time = this.oneMatch.attributes.time;
    //   this.oneMatch.attributes.match_date = this.oneMatch.attributes.date2;
    //   this.updateMatchDetails({ match: this.oneMatch.attributes });
    // },
    ...mapActions({
      getOneChampionship: "Championship/show",
      getOneMatch: "Championship/showMatch",
      getChampTeams: "ChampTeam/index",

      createRound: "Championship/createRound",
      updateRound: "Championship/updateRound",

      createMatch: "Championship/createMatch",
      updateMatchDetails: "Championship/updateMatchDetails"
    })
  },
  computed: {
    ...mapGetters({
      hasWinners: "Championship/hasWinners"
    }),
    matches_comp() {
      if (this.rounds && this.toolbarID >= 0) {
        return this.rounds[this.toolbarID].matches
          ? this.rounds[this.toolbarID].matches.data.map(obj => obj.attributes)
          : [];
      }
    },
    is_owner() {
      return this.oneChampionship.data.attributes.can_edit;
    },
    ...mapState({
      oneMatch: state => state.Championship.oneMatch,
      oneChampionship: state => state.Championship.oneChampionship,
      allChampTeams: state => state.ChampTeam.allChampTeams,

      user: state => state.Users.user,

      createRoundWasGood: state => state.Championship.createRoundWasGood,
      createRoundMessage: state => state.Championship.createRoundMessage,
      updateRoundWasGood: state => state.Championship.updateRoundWasGood,
      updateRoundMessage: state => state.Championship.updateRoundMessage,

      createMatchWasGood: state => state.Championship.createMatchWasGood,
      createMatchMessage: state => state.Championship.createMatchMessage,
      updateMatchWasGood: state => state.Championship.updateMatchWasGood,
      updateMatchMessage: state => state.Championship.updateMatchMessage
    })
  },
  watch: {
    rounds(nv, ov) {
      if (nv) {
        if (!this.$route.params.round) {
          this.toolbarID = 0;
          this.matches = null;
          if (this.rounds.length > 0)
            this.$router.push(
              `/campeonatos/${this.$route.params.id}/jogos/${this.rounds[0].id}`
            );
          // nv.length - 1;
        } else
          this.toolbarID = nv
            .map(o => Number(o.id))
            .indexOf(Number(this.$route.params.round));
      }
    },
    toolbarID(nv, ov) {
      if (nv > -1) {
        this.matches = null;
        this.$router.push(
          `/campeonatos/${this.$route.params.id}/jogos/${this.rounds[nv].id}`
        );
        // this.getRoundMatches(this.rounds[nv].id)
      } else if (nv == false) {
      }
    },
    "newRound.kind"(nv, ov) {
      this.newRound.round_name = null;
      if (nv) {
      } else if (nv == false) {
      }
    },
    date2format(nv) {
      if (nv) {
        this.newMatch.match_date = this.formatDate(nv);
      }
    },
    date2edit(nv) {
      if (nv) {
        this.oneMatch.attributes.date2 = this.formatDate(nv);
      }
    },
    createRoundWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
          (this.newRound = {
            name: null,
            level_configuration_id: null,
            edition_modality_id: null,
            status_id: null,
            round_name: null,
            kind: null
          }),
            (this.dialogCreateRound = false);
          // this.getOneChampionship({ id: this.$route.params.id }).then(() => {});
        }, 500);
      } else if (nv == false) {
      }
    },
    updateRoundWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
          this.getOneChampionship({ id: this.$route.params.id });
        }, 500);
      } else if (nv == false) {
      }
    },

    createMatchWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
          let place = this.newMatch.place;
          (this.newMatch = {
            round_id: null,
            match_time: null,
            match_date: null,
            team_A_id: null, // home
            team_B_id: null, // away
            place
          }),
            (this.date2format = null),
            (this.createGame = false);
          // this.getRoundMatches(this.$route.params.round);
        }, 500);
      } else if (nv == false) {
      }
    },
    // updateMatchWasGood(nv, ov) {
    //   if (nv) {
    //     setTimeout(() => {
    //       this.loading = false;
    //       this.loadTxt = null;
    //       this.getOneChampionship({ id: this.$route.params.id });
    //     }, 500);
    //   } else if (nv == false) {
    //   }
    // },
    createGame(nv, ov) {
      if (nv) {
        if (!this.allChampTeams) {
          this.getChampTeams(this.$route.params.id);
        }
      }
    }
    // oneMatch(nv, ov) {
    //   if (nv) {
    //     this.loading = false;
    //     this.loadTxt = null;
    //   } else if (nv == false) {
    //   }
    // }
  },
  mounted() {
    this.getRounds(this.$route.params.id);
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
</style>


